"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.combinationsDocs = void 0;
var combinationsDocs = {
  name: 'combinations',
  category: 'Probability',
  syntax: ['combinations(n, k)'],
  description: 'Compute the number of combinations of n items taken k at a time',
  examples: ['combinations(7, 5)'],
  seealso: ['combinationsWithRep', 'permutations', 'factorial']
};
exports.combinationsDocs = combinationsDocs;


//////////////////
// WEBPACK FOOTER
// ./node_modules/mathjs/lib/cjs/expression/embeddedDocs/function/probability/combinations.js
// module id = p3lW
// module chunks = 23